import React__default from 'react';

function DownArrowSidebarIcon() {
    return (React__default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M14.12 4L8 10.186L1.88 4L0 5.91375L8 14L16 5.91375L14.12 4Z", fill: "black" }),
        React__default.createElement("mask", { id: "mask0_5915_32", maskUnits: "userSpaceOnUse", x: "0", y: "4", width: "16", height: "10" },
            React__default.createElement("path", { d: "M14.12 4L8 10.186L1.88 4L0 5.91375L8 14L16 5.91375L14.12 4Z", fill: "white" })),
        React__default.createElement("g", { mask: "url(#mask0_5915_32)" },
            React__default.createElement("rect", { width: "16", height: "16", transform: "matrix(0 1 1 0 0 0)", fill: "#999999" }))));
}

export { DownArrowSidebarIcon as default };
//# sourceMappingURL=down-arrow-sidebar.icon.js.map
